if (!customElements.get('carousel-nav-arrows')) {
  class CarouselNavArrows extends HTMLElement {
    connectedCallback() {
      this.prevBtn = this.querySelector('.prev');
      this.nextBtn = this.querySelector('.next');

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.prevBtn?.addEventListener('click', () => this._target()?.prev(), { signal });
      this.nextBtn?.addEventListener('click', () => this._target()?.next(), { signal });

      this._unsubscribe = theme.pubsub?.subscribe?.(theme.pubsub.events.SLIDER_CHANGE, (data) => {
        if (!data || data.id !== this.dataset.target) return;
        this._updateDisabled(data.index, data.total, data.isInfinite);
      });

      this._attrObserver = new MutationObserver(() => this._syncVisibility());
      this._observeTarget();
      this._syncVisibility();
      this._syncInitialDisabled();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this._unsubscribe?.();
      this._attrObserver?.disconnect();
    }

    setTarget(id) {
      this.dataset.target = id;
      this._observeTarget();
      this._syncVisibility();
      this._syncInitialDisabled();
    }

    _target() {
      const id = this.dataset.target;
      return id ? document.getElementById(id) : null;
    }

    _observeTarget() {
      this._attrObserver.disconnect();
      const target = this._target();
      if (target) this._attrObserver.observe(target, { attributes: true, attributeFilter: ['no-scroll'] });
    }

    _syncVisibility() {
      const target = this._target();
      this.hidden = !target || target.hasAttribute('no-scroll');
    }

    _syncInitialDisabled() {
      const target = this._target();
      if (!target) return;
      const infinite = target.dataset.infinite !== 'false';
      this.prevBtn?.toggleAttribute('disabled', !infinite);
      this.prevBtn?.setAttribute('aria-disabled', (!infinite).toString());
      this.nextBtn?.removeAttribute('disabled');
      this.nextBtn?.setAttribute('aria-disabled', 'false');
    }

    _updateDisabled(index, total, isInfinite) {
      const atStart = !isInfinite && index === 0;
      const atEnd = !isInfinite && index === total - 1;
      this.prevBtn?.toggleAttribute('disabled', atStart);
      this.prevBtn?.setAttribute('aria-disabled', atStart.toString());
      this.nextBtn?.toggleAttribute('disabled', atEnd);
      this.nextBtn?.setAttribute('aria-disabled', atEnd.toString());
    }
  }

  customElements.define('carousel-nav-arrows', CarouselNavArrows);
}
